module.exports = {"TXTCLI_Street_Address":{"id":"TXTCLI_Street_Address","defaultMessage":"Почтовый адрес","flags":["TRACK"],"track":"Street Address"}}